export default __webpack_public_path__ + "static/media/Ellie 9781408300305.4f7cebac.jpg";